import React from 'react';
import { useSettings } from '../context/SettingsContext';
import { MessageCircle, Instagram, Sparkles, MapPin, Star } from 'lucide-react';
import SectionDivider from './SectionDivider';

export default function Footer() {
  const { settings } = useSettings();
  const waNumber = (settings.whatsapp_number || '').replace(/\D/g, '');
  const year = new Date().getFullYear();

  return (
    <>
      <SectionDivider />
      <footer className="relative bg-pinky-50 border-t border-pinky-100 mt-4 overflow-hidden" data-testid="site-footer">
        {/* Sparkles decorativas — no tapan texto, pointer-events-none */}
        <Star aria-hidden="true" className="absolute top-6 right-12 h-3 w-3 sm:h-4 sm:w-4 text-amber-300 animate-twinkle pointer-events-none" fill="currentColor" strokeWidth={0} />
        <Sparkles aria-hidden="true" className="absolute top-1/2 left-6 h-3 w-3 sm:h-4 sm:w-4 text-pinky-400 animate-twinkle pointer-events-none hidden sm:block" style={{ animationDelay: '1.2s' }} strokeWidth={2} />
        <Star aria-hidden="true" className="absolute bottom-16 right-1/3 h-3 w-3 text-lilac-400 animate-twinkle pointer-events-none hidden sm:block" style={{ animationDelay: '0.6s' }} fill="currentColor" strokeWidth={0} />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid md:grid-cols-3 gap-10 relative z-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            {settings.logo_url && <img src={settings.logo_url} alt="Gifts GT" className="h-12 w-12" />}
            <p className="font-display text-2xl text-pinky-600">Gifts <span className="text-lilac-400">GT</span></p>
          </div>
          <p className="text-sm text-slate-600 leading-relaxed">
            Importamos productos oficiales de USA, Disney y los parques temáticos para ti 💖. Entrega inmediata en toda Guatemala.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg text-slate-800 mb-3 flex items-center gap-2"><Sparkles className="h-4 w-4 text-pinky-400" /> Contáctanos</h4>
          <a href={`https://wa.me/${waNumber}`} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-slate-600 hover:text-emerald-600 transition-colors" data-testid="footer-whatsapp">
            <MessageCircle className="h-4 w-4" /> {settings.whatsapp_number}
          </a>
          <p className="flex items-center gap-2 text-slate-600 mt-2"><MapPin className="h-4 w-4" /> Guatemala 🇬🇹</p>
          <a href="#" className="flex items-center gap-2 text-slate-600 hover:text-pinky-600 transition-colors mt-2">
            <Instagram className="h-4 w-4" /> @gifts_gt
          </a>
        </div>

        <div>
          <h4 className="font-display text-lg text-slate-800 mb-3 flex items-center gap-2"><Sparkles className="h-4 w-4 text-pinky-400" /> Enlaces</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="#categorias" className="text-slate-600 hover:text-pinky-600">Categorías</a></li>
            <li><a href="#productos" className="text-slate-600 hover:text-pinky-600">Productos</a></li>
            <li><a href="#opiniones" className="text-slate-600 hover:text-pinky-600">Opiniones</a></li>
            <li><a href="#faq" className="text-slate-600 hover:text-pinky-600">FAQ</a></li>
          </ul>
        </div>
      </div>

        <div className="border-t border-pinky-200 py-5 text-center text-xs text-slate-500 relative z-10">
          © {year} Gifts GT — Hecho con 💖 en Guatemala
        </div>
      </footer>
    </>
  );
}
